import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Descarga digital', 'Pago único', 'Sin suscripciones', 'Acceso inmediato'];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-112" data-mp="9k0b6xwjpxkw">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-16 pt-14 text-center sm:pt-20 lg:pb-20" data-id="element-113" data-mp="9ih0rnxkmgr1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[1.95rem] font-black leading-[1.06] tracking-[-0.01em] text-ink xs:text-4xl sm:text-5xl sm:leading-[1.02] lg:text-[4.4rem]" data-id="element-114" data-mp="1297ba1bnev89">
          Aprende Inglés de A1 a C2 de Forma Visual con{' '}
          <span className="italic text-coral" data-id="element-115" data-mp="3d1sa6w93nhsl">+300 Mapas Mentales</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-116" data-mp="3825ywscu0bmf">
          +1200 personas ya estudian de forma fácil y organizada, sin perder horas entre apuntes y explicaciones interminables.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 w-full" data-id="element-117" data-mp="3e8wl4tc6p6nh">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/89ef0934-5aa4-45a1-91e2-bcfb4a006f0e.jpg" alt="Pack de +300 mapas mentales de inglés mostrado en monitor, tablet, teléfono y seis cuadernos por nivel del A1 al C2" className="mx-auto w-full max-w-3xl" width={1200} height={900} data-id="element-118" data-mp="35aueny9ollst" />
        </motion.div>

        

        <div className="mt-9 flex w-full justify-center" data-id="element-119" data-mp="2lla5untlgdks">
          <CtaButton data-id="element-120" data-mp="2lmv0sejtlyj6">Obtén el Pack +300 Mapas Mentales de Inglés™</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-121" data-mp="s3cki77jpdoz">
          {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-122" data-mp="iczzyezqdkiu" data-mpi={index}>
              {index > 0 ? <span aria-hidden="true" className="text-line" data-id="element-123" data-mp="ddwyf4iylwfm">•</span> : null}
              <span data-id="element-124" data-mp="1b0ni7ndj3z2b">{item}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}